import { Button, Col, Container, Image, Row } from 'react-bootstrap'

import Img from "assets/img/common/error.svg"


// import errorSvg from '@/assets/images/element/error.svg'

const ErrorComponent = () => {
  return (
    <>
      <section>
        <Container>
          <Row className="align-items-center mt-8">
            <Col md={10} className="text-center mx-auto flex flex-col items-center justify-center">
              <Image src={Img} className="h-lg-500px mb-4" />
              <h2>Oh no, something went wrong!</h2>
              <p className="mb-4"> please try again later  </p>
              <Button onClick={()=>{
                window.location.href = '/'
              }} className="btn bg-main-color mb-0">
                Take me to Homepage
            </Button>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  )
}

export default ErrorComponent